module.exports = __webpack_public_path__ + "img/director-school-icon4.389d569a.jpg";